export default __webpack_public_path__ + "static/media/wedding-couple.f03613ab.png";